export default __webpack_public_path__ + "static/media/15.fab0afc6.webp";